import { MACRO_MEDIA_BASE } from './media';

export const BRANDS = [
  {
    value: 'carrefour',
    label: 'Carrefour',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/carrefour.png`
  },
  {
    value: 'changomas',
    label: 'Changomas',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/changomas.png`
  },
  {
    value: 'coto',
    label: 'Coto',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/coto.png`
  },
  {
    value: 'adidas',
    label: 'Adidas',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/adidas.jpg`
  },
  {
    value: 'almacor',
    label: 'Almacor',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/almacor.png`
  },
  {
    value: 'almundo',
    label: 'Almundo',
    category: 'viajes',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/almundo.jpg`
  },
  {
    value: 'alvear-sup',
    label: 'Alvear Supermercados',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/alvear-sup.png`
  },
  {
    value: 'assist-card',
    label: 'Assist Card',
    category: 'viajes',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/assist-card.png`
  },
  {
    value: 'baby-cottons',
    label: 'Baby Cottons',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/baby-cottons.jpg`
  },
  {
    value: 'cabify',
    label: 'Cabify',
    category: 'transporte',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/cabify.png`
  },
  {
    value: 'caro-cuore',
    label: 'Caro Cuore',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/caro-cuore.jpg`
  },
  {
    value: 'cetrogar',
    label: 'Cetrogar',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/cetrogar.png`
  },
  {
    value: 'diarco',
    label: 'Diarco',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/diarco.png`
  },
  {
    value: 'diggit',
    label: 'Diggit',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/diggit.png`
  },
  {
    value: 'estacion-libro',
    label: 'Estación Libro',
    category: 'librerias',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/estacion-libro.jpg`
  },
  {
    value: 'farmacity',
    label: 'Farmacity',
    category: 'farmacias',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/farmacity.png`
  },
  {
    value: 'freddo',
    label: 'Freddo',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/freddo.png`
  },
  {
    value: 'grimoldi',
    label: 'Grimoldi',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/grimoldi.jpg`
  },
  {
    value: 'guapaletas',
    label: 'Guapaletas',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/guapaletas.png`
  },
  {
    value: 'havanna',
    label: 'Havanna',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/havanna.png`
  },
  {
    value: 'hergo',
    label: 'Hergo',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/hergo.jpg`
  },
  {
    value: 'juleriaque',
    label: 'Juleriaque',
    category: 'salud-y-belleza',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/juleriaque.png`
  },
  {
    value: 'kiehls',
    label: "Kiehl's",
    category: 'salud-y-belleza',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/kiehls.png`
  },
  {
    value: 'la-pinocha',
    label: 'La Pinocha',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/la-pinocha.png`
  },
  {
    value: 'lancome',
    label: 'Lancôme',
    category: 'salud-y-belleza',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/lancome.png`
  },
  {
    value: 'lg',
    label: 'LG',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/lg.png`
  },
  {
    value: 'mac-cosmetics',
    label: 'MAC Cosmetics',
    category: 'salud-y-belleza',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/mac-cosmetics.png`
  },
  {
    value: 'macowens',
    label: 'Macowens',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/macowens.jpg`
  },
  {
    value: 'makro',
    label: 'Makro',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/makro.png`
  },
  {
    value: 'masonline',
    label: 'Más Online',
    category: 'supermercados',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/masonline.png`
  },
  {
    value: 'mcdonalds',
    label: "McDonald's",
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/mcdonalds.png`
  },
  {
    value: 'motorola',
    label: 'Motorola',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/motorola.png`
  },
  {
    value: 'musimundo',
    label: 'Musimundo',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/musimundo.jpg`
  },
  {
    value: 'naldo',
    label: 'Naldo',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/naldo.jpeg`
  },
  {
    value: 'neumen-negro',
    label: 'Neumen',
    category: 'automotor',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/neumen-negro.png`
  },
  {
    value: 'nike',
    label: 'Nike',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/nike.jpg`
  },
  {
    value: 'oncity',
    label: 'On City',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/oncity.png`
  },
  {
    value: 'paladar',
    label: 'Paladar',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/paladar.png`
  },
  {
    value: 'paruolo',
    label: 'Paruolo',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/paruolo.jpg`
  },
  {
    value: 'patiobullrich',
    label: 'Patio Bullrich',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/patiobullrich.jpg`
  },
  {
    value: 'persicco',
    label: 'Persicco',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/persicco.jpeg`
  },
  {
    value: 'pigmento',
    label: 'Pigmento',
    category: 'salud-y-belleza',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/pigmento.png`
  },
  {
    value: 'pirelli',
    label: 'Pirelli',
    category: 'automotor',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/pirelli.png`
  },
  {
    value: 'rapsodia',
    label: 'Rapsodia',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/rapsodia.jpg`
  },

  {
    value: 'sbs-libreria',
    label: 'SBS Librería',
    category: 'librerias',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/sbs-libreria.png`
  },
  {
    value: 'selvatica',
    label: 'Selvática',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/selvatica.jpg`
  },
  {
    value: 'shop-gallery',
    label: 'Shop Gallery',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/shop-gallery.png`
  },
  {
    value: 'showsport',
    label: 'Showsport',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/showsport.jpg`
  },
  {
    value: 'simplicity',
    label: 'Simplicity',
    category: 'salud-y-belleza',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/simplicity.png`
  },
  {
    value: 'smartlife',
    label: 'Smartlife',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/smartlife.png`
  },
  {
    value: 'stockcenter',
    label: 'Stock Center',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/stockcenter.jpg`
  },
  {
    value: 'the-food-market',
    label: 'The Food Market',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/the-food-market.png`
  },
  {
    value: 'trescha',
    label: 'Trescha',
    category: 'gastronomia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/trescha.png`
  },
  {
    value: 'tuenti',
    label: 'Tuenti',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/tuenti.png`
  },
  {
    value: 'uber',
    label: 'Uber',
    category: 'transporte',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/uber.jpg`
  },
  {
    value: 'under-armour',
    label: 'Under Armour',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/under-armour.png`
  },
  {
    value: 'xiaomi',
    label: 'Xiaomi',
    category: 'electro-y-tecnologia',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/xiaomi.jpg`
  },
  {
    value: 'yenny',
    label: 'Yenny',
    category: 'librerias',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/yenny.jpg`
  },
  {
    value: 'zara',
    label: 'Zara',
    category: 'indumentaria',
    imageUrl: `${MACRO_MEDIA_BASE}/logos/brands/zara.jpg`
  }
];
